<template>
    <div class="mint-selected-footer __emapm">
        <div v-show="!isShowDetail" class="mint-selected-footer-bar">
            <mt-button class="mint-selected-footer-detail" :disabled="value.length === 0" size="large" @click="isShowDetail = true">查看已选({{value.length}})</mt-button>
            <mt-button class="mint-selected-footer-confirm" size="large" type="primary" @click="handleConfirm">确定</mt-button>
        </div>
        <div v-show="isShowDetail" class="mint-selected-footer-list-mask"></div>
        <div v-show="isShowDetail" class="mint-selected-footer-list-container">
            <div class="mint-selected-footer-list-header">
                <a href="javascript:void(0)" @click="handleCancel">取消</a>
                <span>已选({{value.length}})</span>
                <a @click="handleClickListConfirm" class="mint-selected-footer-list-confirm" href="javascript:void(0)">确定</a>
            </div>
            <div class="mint-selected-footer-list">
                <mt-box-group v-model="currentValue">
                    <mt-cell-group>
                        <mt-checkbox :name="item.value" :disabled="item.disabled" v-for="item in listData">
                            {{item.label}}
                        </mt-checkbox>
                    </mt-cell-group>
                </mt-box-group>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        options: { required: true, type: Array },
        value: { required: true, type: Array }
    },
    data() {
        return {
            isShowDetail: false,
            currentValue: []
        };
    },
    watch: {
        value(val) {
            this.currentValue = val.slice(0, this.value.length);
        }
    },
    computed: {
        listData() {
            if (this.value.length === 0 || this.options.length === 0) {
                return [];
            }
            return this.options.filter(item => {
                return this.value.indexOf(item.id.toString()) > -1;
            }).map(item => {
                return {
                    label: item.name,
                    value: item.id
                };
            });
        }
    },
    methods: {
        handleCancel() {
            this.currentValue = JSON.parse(JSON.stringify(this.value));
            this.isShowDetail = false;
        },
        handleClickListConfirm() {
            this.$emit('input', this.currentValue);
            this.isShowDetail = false;
        },
        handleConfirm() {
            this.$emit('confirm-click');
        }
    },
    created() {
        this.currentValue = this.value.slice(0, this.value.length);
    }
};
</script>
<style scoped>
.mint-selected-footer.__emapm {
    z-index: 2;
    position: absolute;
}

.mint-selected-footer-list-mask {
    background-color: rgba(0, 0, 0, .5);
}

.mint-selected-footer-list-container{
    background-color: white;
}
</style>


// WEBPACK FOOTER //
// baseSelectorFooter.vue?e04f137c